export { FgTypeaheadComponent } from './fg-typeahead.component';
export { FgTypeaheadModule } from './fg-typeahead.module';
